



import BackButton from '@/components/common/back-button/BackButton.vue'
import MarkedText from '@/components/common/marked-text/MarkedText.vue'
import PartsGallery from '@/components/products/parts/parts-gallery/PartsGallery.vue'
import PartsList from '@/components/products/parts/parts-list/PartsList.vue'
import PartsPage from '@/components/products/PartsPage'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
  components: {
    BackButton,
    PartsList,
    PartsGallery,
    MarkedText
  }
})
export default class Parts extends Vue {
  @Prop({required: true}) pageId!: number
  page: PartsPage = null as any

  created() {
    this.fetchPage()
  }

  @Watch('pageId')
  onCategoryUpdated() {
    this.fetchPage()
  }

  private async fetchPage() {
    const {data} = await this.$axios.get<PartsPage>(`/parts-pages/${this.pageId}`)
    this.page = data
  }
}
